import { nFormatter } from "utils/parseNumber";

import IMAGE_ICON from "components/icons/Eye_Show.svg";
import VIDEO_ICON from "components/icons/playIcon.svg";
import SEARCH_ICON from "components/icons/search.svg";

import "./buttons.scss";

export enum ViewsButtonType {
  VIDEO = 1,
  IMAGE = 2,
  SEARCH = 3
}

export const ViewsButton = (props: {
  count: number;
  onClick?: () => void;
  type?: ViewsButtonType;
}): JSX.Element => {

  const renderIconUrl = () => {
    const { IMAGE, SEARCH } = ViewsButtonType;

    if (props.type === IMAGE) {
      return IMAGE_ICON;
    }

    if (props.type === SEARCH) {
      return SEARCH_ICON;
    }

    return VIDEO_ICON;
  };

  const onClick = () => {
    props.onClick && props.onClick();
  };

  return (
    <button
      className="rg-button views icon"
      onClick={onClick}
    >
      <img src={renderIconUrl()} alt="" />
      <div className="label">{nFormatter(props.count)}</div>
    </button>
  );
};
